const AUTH_ACTIONS = {
	login: "LOGIN",
	logout: "LOGOUT",
	config: "CONFIG",
	modules: "MODULES",
};

let initialState = {
	authenticated: localStorage.getItem("authenticated") ? true : false,
	config: { loading: true },
	modules: { loading: true },
	lastLogin: new Date().toISOString(),
};

const authorization = (state = initialState, { data, type }) => {
	if (type === AUTH_ACTIONS.login) {
		return {
			...state,
			authenticated: true,
			lastLogin: new Date().toISOString(),
		};
	} else if (type === AUTH_ACTIONS.logout) {
		return initialState;
	} else {
		return state;
	}
};

export { AUTH_ACTIONS, authorization };
